module.exports = __webpack_public_path__ + "static/media/b2.855e7f3f.PNG";